import React, { Component } from "react";
import t from "tcomb-form";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
// import Form from "react-bootstrap/Form";
import {
  Container,
  Button,
  Row,
  Col,
  Card,
  Image,
  Alert
} from "react-bootstrap";
import myCustomTemplate from "../Common/customTemplate";
import "./login.css";
export interface Props {
  logins: any;
}
export interface State {}

const UserIDField = t.refinement(t.String, value => {
  return value.length > 0;
});
const PasswordMinLength = t.refinement(t.String, value => {
  return value.length > 0;
});

const Form = t.form.Form;
const Person = t.struct({
  UserID: UserIDField,
  password: PasswordMinLength
});

const options = {
  fields: {
    UserID: {
      template: myCustomTemplate,
      config: {
        placeholder: "Mobile Number",
        errorMessage: "Please enter the registered mobile number",
        labelHide: true,
        type: "text"
      }
    },
    password: {
      template: myCustomTemplate,
      config: {
        placeholder: "Password",
        errorMessage: "Please enter your password",
        type: "password"
      }
    }
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: options,
      value: {
        UserID: "",
        password: ""
      }
    };
  }

  onChange = (Person1, path) => {
    this.refs.form.getComponent(path).validate();
  };
  submit = event => {
    var value = this.refs.form.getValue();

    event.preventDefault();
    if (value) {
      this.props.logins(value);
    }
  };

  render() {
    return (
      <div>
        <Navbar></Navbar>

        <div className="bgcolorLogin container-fluid">
          <div>
            <div>
              <Container>
                <div className="cardMainlogin">
                  <Row>
                    <Col xs={12} md={6} sm={12} lg={6}>
                      <div>
                        <img
                          className="loginimage"
                          src={require("../../assets/img/hero-img (2).png")}
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={1} sm={12} lg={1}></Col>
                    <Col xs={12} md={4} sm={12} lg={4}>
                      <div className="loginheaderfrst">
                        <div>
                          <h3 className="loginheader">Login</h3>
                          <div className="loginundelne"></div>
                        </div>
                        {/* <Link to="/signup" className="signupanaccount">
                          Don't have an account?
                          <span className="accountsignup"> Create Account</span>
                        </Link> */}
                        <div className="loginform">
                          <form onSubmit={this.submit}>
                            {/* Form will be submitted when enter key is pressed */}
                            <Form
                              className="loginform"
                              ref="form"
                              type={Person}
                              options={this.state.options}
                              value={this.state.value}
                              onChange={(v, path) => this.onChange(v, path)}
                            />

                            <Button
                              className="contactpagebtn"
                              size="lg"
                              //onClick={this.submit}
                              type="submit"
                            >
                              Login
                            </Button>
                          </form>
                          <Link to="/signup" className="signupanaccount">
                            Don't have an account?
                            <span className="accountsignup">
                              {" "}
                              Create Account
                            </span>
                          </Link>
                          <div className="forgotPswddiv">
                            <Link to="/forgotpassword" className="forgotPswd">
                              Forgot password?
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
